import React from 'react';
import DeliveryFormPageContainer from './DeliveryFormPageContainer'

export class DeliveryFormPage extends React.Component {
    render(){
        return (
            <DeliveryFormPageContainer {...this.props}/>
        )
    }
}